import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=5016a020&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=5016a020&prod&lang=css"
import style1 from "./Statistics.vue?vue&type=style&index=1&id=5016a020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5016a020",
  null
  
)

export default component.exports